// Traduzioni delle pagine legali — Privacy e Termini in inglese e tedesco
export const legalTranslations = {
  en: {
    privacy: {
      title: "Privacy Policy | DJ Magix",
      description:
        "DJ Magix privacy policy: what data we collect, how we use it and your rights under the Swiss FADP and the GDPR.",
      eyebrow: "Legal Document",
      heading: "Privacy Policy",
      sections: [
        {
          h2: "1. Data controller",
          text: "DJ Magix, based in Lugano-Paradiso (Ticino, Switzerland). Contact: info@djmagix.net — Tel +41 76 441 13 59. For any question about your data you can write to this address.",
        },
        {
          h2: "2. What data we collect",
          text: "Contact and quote form: name, email, phone and the event details you send us voluntarily, used solely to reply to you and prepare the quote. Analytics tools (only with your consent): Google Analytics 4 with anonymised IP address and Microsoft Clarity, which record in aggregate form how the site is used (pages visited, clicks, mouse movement). With the same consent we also record internal visit statistics in anonymous form (shortened IP address, approximate city, device type), visible only to the controller in his dashboard.",
        },
        {
          h2: "3. Legal basis and consent",
          text: "The processing of form data is based on your contact request. Analytics tools are loaded only after your explicit consent via the cookie banner; you can refuse without any consequence on browsing and change your mind at any time from the 'Cookie preferences' link in the footer.",
        },
        {
          h2: "4. Sharing and retention",
          text: "Your data is never sold or passed to third parties for marketing purposes. Retention: quote requests that are no longer active (never converted or lost leads) are automatically deleted after 24 months; anonymous analytics data (visits) after 12 months; privacy and newsletter consents are recorded in a dedicated register (date, accepted text, anonymised IP) as proof of consent. Newsletter subscription happens only with your explicit consent and you can unsubscribe with one click in every email. You can request deletion of your data at any time.",
        },
        {
          h2: "5. Your rights (FADP and GDPR)",
          text: "Under the Swiss Federal Act on Data Protection (FADP) and, where applicable, the GDPR, you have the right of access, rectification, deletion and objection to the processing of your data. To exercise them write to info@djmagix.net: we will reply personally.",
        },
        {
          h2: "6. Changes to this policy",
          text: "This policy may be updated over time; the version published on this page is the current one. Last updated: October 2026.",
        },
      ],
    },
    termini: {
      title: "Terms of Service | DJ Magix",
      description:
        "Terms of service of djmagix.net: quotes, intellectual property, liability and applicable law.",
      eyebrow: "Legal Document",
      heading: "Terms of Service",
      sections: [
        {
          h2: "1. Purpose",
          text: "These terms govern the use of the djmagix.net website, showcasing the services of DJ Magix (Lugano-Paradiso, Ticino, Switzerland): DJ sets for weddings, private parties, village festivals and corporate events, music productions and related services.",
        },
        {
          h2: "2. Quotes and bookings",
          text: "Requests sent through the site (form, phone, WhatsApp or email) are non-binding: every service is confirmed only after a written quote accepted by both parties. The prices shown on the site (starting from CHF 150) are indicative and may vary depending on duration, venue, equipment and requested effects.",
        },
        {
          h2: "3. Content and intellectual property",
          text: "Texts, logo, images, mixes and videos on this site are the property of DJ Magix or used under licence. Reproduction or redistribution without written authorisation is not permitted. The mixes available for listening are protected by copyright and intended for personal listening only.",
        },
        {
          h2: "4. Liability",
          text: "We strive to keep the information on the site accurate and up to date; however we do not guarantee the absence of errors. We are not responsible for the content of external sites reachable via links (e.g. Instagram, maps).",
        },
        {
          h2: "5. Applicable law",
          text: "These terms are governed by Swiss law. For any dispute the court of Lugano (Ticino) has jurisdiction. Questions: info@djmagix.net.",
        },
      ],
    },
  },
  de: {
    privacy: {
      title: "Datenschutzerklärung | DJ Magix",
      description:
        "Datenschutzerklärung von DJ Magix: welche Daten wir erheben, wie wir sie verwenden und Ihre Rechte nach dem Schweizer DSG und der DSGVO.",
      eyebrow: "Rechtsdokument",
      heading: "Datenschutzerklärung",
      sections: [
        {
          h2: "1. Verantwortliche Stelle",
          text: "DJ Magix, mit Sitz in Lugano-Paradiso (Tessin, Schweiz). Kontakt: info@djmagix.net — Tel +41 76 441 13 59. Für Fragen zu Ihren Daten können Sie an diese Adresse schreiben.",
        },
        {
          h2: "2. Welche Daten wir erheben",
          text: "Kontakt- und Offertenformular: Name, E-Mail, Telefon und die Angaben zum Anlass, die Sie uns freiwillig senden — verwendet ausschliesslich zur Beantwortung und zur Erstellung der Offerte. Analysewerkzeuge (nur mit Ihrer Einwilligung): Google Analytics 4 mit anonymisierter IP-Adresse und Microsoft Clarity, die in aggregierter Form aufzeichnen, wie die Website genutzt wird (besuchte Seiten, Klicks, Mausbewegungen). Mit derselben Einwilligung erfassen wir auch interne Besuchsstatistiken in anonymer Form (gekürzte IP-Adresse, ungefähre Stadt, Gerätetyp), die nur für die verantwortliche Person in ihrem Dashboard sichtbar sind.",
        },
        {
          h2: "3. Rechtsgrundlage und Einwilligung",
          text: "Die Verarbeitung der Formulardaten beruht auf Ihrer Kontaktanfrage. Die Analysewerkzeuge werden erst nach Ihrer ausdrücklichen Einwilligung über das Cookie-Banner geladen; Sie können ablehnen, ohne jede Auswirkung auf die Navigation, und Ihre Meinung jederzeit über den Link 'Cookie-Einstellungen' im Fussbereich ändern.",
        },
        {
          h2: "4. Weitergabe und Aufbewahrung",
          text: "Ihre Daten werden weder verkauft noch zu Marketingzwecken an Dritte weitergegeben. Aufbewahrung: nicht mehr aktive Offertanfragen (nie konvertierte oder verlorene Leads) werden nach 24 Monaten automatisch gelöscht; anonyme Analysedaten (Besuche) nach 12 Monaten; Datenschutz- und Newsletter-Einwilligungen werden in einem eigenen Register (Datum, akzeptierter Text, anonymisierte IP) als Nachweis der Einwilligung festgehalten. Die Anmeldung zum Newsletter erfolgt nur mit Ihrer ausdrücklichen Einwilligung, und Sie können sich mit einem Klick in jeder E-Mail abmelden. Sie können jederzeit die Löschung Ihrer Daten verlangen.",
        },
        {
          h2: "5. Ihre Rechte (DSG und DSGVO)",
          text: "Nach dem Schweizer Datenschutzgesetz (DSG) und, soweit anwendbar, der DSGVO haben Sie das Recht auf Auskunft, Berichtigung, Löschung und Widerspruch gegen die Verarbeitung Ihrer Daten. Zur Ausübung schreiben Sie an info@djmagix.net: Wir antworten persönlich.",
        },
        {
          h2: "6. Änderungen dieser Erklärung",
          text: "Diese Erklärung kann im Laufe der Zeit aktualisiert werden; die auf dieser Seite veröffentlichte Version ist die gültige. Letzte Aktualisierung: Oktober 2026.",
        },
      ],
    },
    termini: {
      title: "AGB | DJ Magix",
      description:
        "Allgemeine Geschäftsbedingungen der Website djmagix.net: Offerten, geistiges Eigentum, Haftung und anwendbares Recht.",
      eyebrow: "Rechtsdokument",
      heading: "Allgemeine Geschäftsbedingungen",
      sections: [
        {
          h2: "1. Gegenstand",
          text: "Diese Bedingungen regeln die Nutzung der Website djmagix.net, Schaufenster der Dienstleistungen von DJ Magix (Lugano-Paradiso, Tessin, Schweiz): DJ-Sets für Hochzeiten, private Feste, Dorffeste und Firmenevents, Musikproduktionen und damit verbundene Dienstleistungen.",
        },
        {
          h2: "2. Offerten und Buchungen",
          text: "Anfragen über die Website (Formular, Telefon, WhatsApp oder E-Mail) sind unverbindlich: Jede Dienstleistung wird erst nach einer schriftlichen, von beiden Parteien akzeptierten Offerte bestätigt. Die auf der Website angegebenen Preise (ab CHF 150) sind Richtwerte und können je nach Dauer, Location, Ausrüstung und gewünschten Effekten variieren.",
        },
        {
          h2: "3. Inhalte und geistiges Eigentum",
          text: "Texte, Logo, Bilder, Mixe und Videos auf dieser Website sind Eigentum von DJ Magix oder werden mit Lizenz verwendet. Vervielfältigung oder Weiterverbreitung ohne schriftliche Genehmigung ist nicht gestattet. Die zum Anhören bereitstehenden Mixe sind urheberrechtlich geschützt und nur für das persönliche Anhören bestimmt.",
        },
        {
          h2: "4. Haftung",
          text: "Wir bemühen uns, die Informationen auf der Website korrekt und aktuell zu halten; wir garantieren jedoch nicht die Fehlerfreiheit. Für Inhalte externer Websites, die über Links erreichbar sind (z. B. Instagram, Karten), übernehmen wir keine Verantwortung.",
        },
        {
          h2: "5. Anwendbares Recht",
          text: "Diese Bedingungen unterstehen dem Schweizer Recht. Für alle Streitigkeiten ist das Gericht in Lugano (Tessin) zuständig. Fragen: info@djmagix.net.",
        },
      ],
    },
  },
};
